export default __webpack_public_path__ + "static/char-v-49-b7feb3e1c8288e4c57c3172f8ed3c3e5.webp";